import { render, staticRenderFns } from "./vllabel.vue?vue&type=template&id=3811e7a7&scoped=true"
import script from "./vllabel.vue?vue&type=script&lang=js"
export * from "./vllabel.vue?vue&type=script&lang=js"
import style0 from "./vllabel.vue?vue&type=style&index=0&id=3811e7a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3811e7a7",
  null
  
)

export default component.exports